<template>
  <el-container height="auto">
    <el-aside width="250px" style="border-right: 0px solid #e7e9eb;
    position: relative;
    outline: none;
    color: #767c85;margin-top:20px;margin-bottom:20px;">

        </el-aside>
    <el-main>


        

       
    </el-main>
    <el-aside width="250px" style="border-left: 0px solid #e7e9eb;
    position: relative;
    outline: none;
    color: #767c85;margin-top:20px;margin-bottom:20px;">


        </el-aside>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        subjectid: 0,
        form: {
          subjectname: '',
          initials: '',
          sex: '',
          dob: '',
          category:'',
          comments: '',
          personalid:'',
          phone:'',
          subjectnumber:''
        },
        rules: {
          subjectname: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ]
        }
      }
    },
    mounted(){
      this.getSubjectInfo(this.$route.params.subjectid);
    },
    methods: {
        onSave(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
              this.$http.post("subject/edit",this.form).then((res) => { 
                if(!res) return;
                //提醒成功
                this.$message({ type:'success', message:'病例编辑成功'})
              });
          }
          
        });
      },
      getSubjectInfo(subjectid){
        if(!subjectid) return;
        this.$http.get('subject/info',
        {
          params:{subjectid:subjectid}
        })
        .then((res) => { 
          this.form = res.data.info;
        });
      }
    }
  }
</script>
<style scoped>
iframe {
  width:100%;
  height:100%;
}
</style>